module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"padded\">\n	<table class=\"form-table\">\n		<tr>\n			<td>Долгота крайней западной точки <span class=\"required\"></span></td>\n			<td><control type=\"text\" target=\"item.westlon\"/></td>\n		</tr>\n		<tr>\n			<td>Долгота крайней восточной точки <span class=\"required\"></span></td>\n			<td><control type=\"text\" target=\"item.eastlon\"/></td>\n		</tr>\n		<tr>\n			<td>Широта крайней южной точки <span class=\"required\"></span></td>\n			<td><control type=\"text\" target=\"item.southlat\"/></td>\n		</tr>\n		<tr>\n			<td>Широта крайней северной точки <span class=\"required\"></span></td>\n			<td><control type=\"text\" target=\"item.northlat\"/></td>\n		</tr>\n	</table>\n</div>\n")
  }
  return __output.join("");

}